const MyInfoData = {
  firstName: "John",
  lastName: "Doe",
  email: "abc@gmail.com",
  company: "ABC",
  phoneNumber: "1234567890",
  address: "1234 Main St",
};

export { MyInfoData };
